import React from 'react';
import ImgMedidor from 'assets/images/relogio-medidor.png';

import { AiOutlineWarning } from 'react-icons/ai';

import {
  Container,
  Title,
  SubTitle,
  Img,
  ButtonOK,
  TitleWrap,
  CardInfo,
  CardInfoIcon,
  CardInfoText,
  ImgWrapper,
} from './styles';

type ModalGaugeProps = {
  closeModal: () => void;
};

const ModalGauge: React.FC<ModalGaugeProps> = ({ closeModal }) => {
  return (
    <Container>
      <TitleWrap>
        <Title>Onde verifico o nível do meu gás?</Title>
      </TitleWrap>
      <SubTitle>
        Você encontrará a informação sobre o percentual de gás na parte superior
        do vasilhame em sua base instalada, conforme ilustrado na foto abaixo:
      </SubTitle>
      <CardInfo>
        <CardInfoIcon>
          <AiOutlineWarning size={24} color="#F5A623" />
        </CardInfoIcon>
        <CardInfoText>
          Para garantir a sua segurança, recomendamos que nunca tire fotos
          próximo ao vasilhame de gás. Este tipo de equipamento requer cuidados
          especiais para evitar riscos de vazamento, explosão ou outros
          acidentes.
        </CardInfoText>
      </CardInfo>
      <ImgWrapper>
        <Img src={ImgMedidor} />
      </ImgWrapper>
      <ButtonOK onClick={() => closeModal()}>Fechar</ButtonOK>
    </Container>
  );
};

export default ModalGauge;
